<div class="modal">
  <div class="container model-container {{data.customClass}}">
    <img src="assets/icon/popup-close-icon.svg" (click)="closeDialog()" class="close-icon" width="32" height="32"
      alt="Close Icon">
    <div class="modal-header">
      <h4 class="modal-heading">Add a New Card</h4>
    </div>
    <div class="modal-body">
      <div class="modal-content">
        <p class="text-bold text-content">Credit Card Details</p>

        <lib-stripe-payment id="newPaymentSection" [loaderPath]="'/assets/img/loader.gif'" [loaderColor]="'#FFC649'"
          [generic]="true" [businessName]="businessName" (createPaymentProfile)="createPaymentProfile()"
          (confimationToken)="handleConfirmationToken($event)" (appStateLoading)="handleLoading($event)"
          (addressIsNotVerified)="handleAddressVerification($event)"
          [componentDesc]="componentDesc" [autoRenew]="false" [email]="this.data.user?.email">
        </lib-stripe-payment>
      </div>
    </div>
  </div>
</div>
